<template>
  <div class="wrapper wrapper-content  animated fadeInRight">
    <div class="ibox">
      <div class="ibox-title">
        <h5>Build Queue</h5>
      </div>
      <div class="ibox-content col-lg-12">
        <div class="col-lg-12 m-t-sm"></div>
        <list></list>
      </div>
    </div>
  </div>
</template>
<script>
import List from './Queue/List'
export default {
  data () {
    return {
      queue: true
    }
  },
  components: {
    list: List
  },
  mounted () {
    document.title = 'Build Queue :: PBN360 by Aphex Media'
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Pages/Pbn/Build/Queue.vue